import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledCardsContainer } from './VoucherApplicationsStyle';
import './VoucherApplicationsTranslate';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearState,
  loadApplications,
  voucherApplicationsModule,
  applicationDownload,
  revokeByApplicant,
  rejectVoucherByApplicant,
  canGetVoucher,
  confirmInterest
} from './VoucherApplicationsDucks';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import StaticTablePaginated from '../../_ui/Table/StaticTablePaginated';
import Typography from '@material-ui/core/Typography';
import { requestsColumns } from './TableColumns/TableColumns';
import i18n from 'i18next';
import useModal from '../../modules/_hooks/useModal';
import DialogVoucher from './Dialogs/DialogVoucher';
import { useHistory } from 'react-router-dom';

function VoucherApplications() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { data, pageNumber, totalElements, loading } = useSelector(
    state => state[voucherApplicationsModule]
  );
  const loadData = filter => dispatch(loadApplications(filter));
  const modalRevoke = useModal('voucherRevoke');
  const modalRejectVoucher = useModal('voucherReject');
  const modalInterested = useModal('voucherInterested');
  const { push } = useHistory();

  const handleDone = async () => {
    dispatch(revokeByApplicant(modalRevoke.data.id, modalRevoke, filter));
  };
  const handleInterested = async () => {
    dispatch(confirmInterest(modalInterested.data.id, modalInterested, filter));
  };
  const handleDoneForReject = async () => {
    dispatch(
      rejectVoucherByApplicant(modalRejectVoucher.data.id, modalRejectVoucher, filter)
    );
  };

  const checkBulletins = data => {
    dispatch(canGetVoucher(data, push));
  };

  const { toPage, filter } = useTableFilter(loadData, '', {
    pageNumber: 1,
    pageSize: 10,
    isActive: null,
    isArchived: null
  });

  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);

  const downloadApplication = requestFormId => {
    dispatch(applicationDownload({ requestFormId }));
  };

  return (
    <div className="mb3 mt3" style={{ width: '100%' }}>
      <Typography
        children={t('voucher_applications_subtitle')}
        color="secondary"
        variant="h6"
        style={{ paddingLeft: '10px' }}
      />
      <StyledCardsContainer>
        <StaticTablePaginated
          TheadComponent={_ => null}
          pageNumber={pageNumber}
          loading={loading}
          data={data}
          totalElements={totalElements}
          columns={requestsColumns({
            t,
            filter,
            pageNumber,
            lang: i18n.language,
            modalRejectVoucher,
            downloadApplication,
            modalRevoke,
            checkBulletins,
            modalInterested
          })}
          filterable={false}
          pageSize={10}
          pagePagination={page => {
            if (page !== pageNumber) {
              toPage(page);
            }
          }}
        />
      </StyledCardsContainer>
      <DialogVoucher
        modalBody={t('voucher_applications_modalBodyRejectVoucher')}
        modalTitle={t('voucher_applications_modalTitleRejectVoucher')}
        open={modalRejectVoucher.isOpen}
        handleClose={modalRejectVoucher.close}
        handleDone={handleDoneForReject}
      />
      <DialogVoucher
        modalBody={t('voucher_applications_modalBodyRevoke')}
        modalTitle={t('voucher_applications_modalTitleRevoke')}
        open={modalRevoke.isOpen}
        handleClose={modalRevoke.close}
        handleDone={handleDone}
      />
      <DialogVoucher
        modalBody={t('voucher_applications_modalBodyInterested')}
        modalTitle={t('voucher_applications_modalTitleInterested')}
        open={modalInterested.isOpen}
        handleClose={modalInterested.close}
        handleDone={handleInterested}
      />
    </div>
  );
}

export default VoucherApplications;
